export default __webpack_public_path__ + "static/media/endorsement-san-archery.3ea8bf06.png";